module.exports = __webpack_public_path__ + "static/rockland-logo-a6695823371bcdbbf67caf912c1dd70b.jpg";